"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeString = void 0;
var capitalizeString = function capitalizeString(text) {
  return "".concat(text.charAt(0).toUpperCase()).concat(text.slice(1));
}; // eslint-disable-line import/prefer-default-export

exports.capitalizeString = capitalizeString;